import headerAvatar   from '@/shared/icons/Gamification/header-avatar.svg';
import headerCalendar from '@/shared/icons/Gamification/header-calendar.svg';

export const HEADER_IMAGES = {
  avatar:       headerAvatar,
  calendarIcon: headerCalendar,
};

// ── Couleurs du design system ─────────────────────────────────────────────────
export const COLORS = {
  textStrong: '#343535',
  textMedium: '#58595b',
  textWeak: '#939597',
  progressGreen: '#26ac30',
  progressGray: '#ECEEF3',
};

export const CATEGORIES_ORDER = [
  { id: 'contract' },
  { id: 'axa'},
  { id: 'offset'},
  { id: 'lead'},
  { id: 'protected'},
  { id: 'neat'},
  { id: 'nlbp'},
  { id: 'myselectra'},
];

// ── Niveaux (hors "empty") pour la section "Niveaux en cours" ────────────────
export const LEVELS_ORDER = [
  { key: 'beginner',  order: 1 },
  { key: 'bronze',    order: 2 },
  { key: 'silver',    order: 3 },
  { key: 'gold',      order: 4 },
  { key: 'platinium', order: 5 },
  { key: 'diamond',   order: 6 },
  { key: 'elite',     order: 7 },
];

